module.exports = __webpack_public_path__ + "static/media/datasheet_listData_row5_startplaying.b6e1144a.png";